import { useState, useRef, useEffect } from "react";
import Input from "./Input";
const MultiSelectWrapper = ({
  id,
  options = [],
  value = [],
  onChange,
  placeholder = "Select",
  error,
  isSportsList,
  isSearch,
  searchPlaceHolder,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef();
  const [optionsData, setOptionData] = useState(options);
  useEffect(() => {
    const close = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const toggleOption = (id) => {
    if (value.includes(id)) {
      onChange(value.filter((v) => v !== id));
    } else {
      onChange([...value, id]);
    }
  };

  const selectedOptions = optionsData?.filter((o) =>
    value?.includes(isSportsList ? o.name : o.id || o)
  );
  const handleSearch = (searchName) => {
    const filteredUsers = options?.filter((user) =>
      user.name.toLowerCase().includes(searchName.toLowerCase())
    );
    setOptionData(filteredUsers);
  };

  return (
    <div className="relative w-full" ref={wrapperRef}>
      {/* Trigger Input */}
      <div
        onClick={() => setOpen(!open)}
        className={`w-full border-2 rounded-lg px-4 py-3 bg-white cursor-pointer flex justify-between items-center
            ${
              open
                ? "border-[#2BACE2] shadow-lg shadow-blue-100"
                : "border-gray-200"
            }`}
      >
        {value.length ? (
          <span className="text-gray-700 text-sm">
            Selected ({value.length})
          </span>
        ) : (
          <span className="text-gray-400 text-sm">{placeholder}</span>
        )}

        <svg
          className={`w-4 h-4 text-gray-400 transition-transform ${
            open ? "rotate-180" : "rotate-0"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-50 mt-2 w-full bg-white rounded-lg border border-gray-200 shadow-lg max-h-auto overflow-y-auto">
          {isSearch && (
            <Input
              type="text"
              onChange={(val) => handleSearch(val)}
              className="p-3"
              placeholder={"Search.."}
            />
          )}
          {optionsData?.map((opt) => (
            <label
              key={opt?.id ?? opt}
              className={`flex items-center px-4 py-2 
                ${
                  opt?.disable
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer hover:bg-gray-100"
                }`}
            >
              <input
                type="checkbox"
                checked={value?.includes(
                  isSportsList ? opt?.name : opt?.id || opt
                )}
                onChange={() =>
                  !opt?.disable &&
                  toggleOption(isSportsList ? opt?.name : opt?.id || opt)
                }
                disabled={opt?.disable}
                className="mr-2 h-4 w-4"
              />
              {isSportsList ? `${opt?.icon} ${opt?.name}` : opt?.name || opt}
            </label>
          ))}
        </div>
      )}

      {/* Tags */}
      {selectedOptions?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {selectedOptions?.map((opt) => (
            <span
              key={opt.id}
              className="bg-[#2bace229] text-[#2bace2] text-xs font-medium px-2 py-1 rounded-full flex items-center"
            >
              {isSportsList ? `${opt?.icon} ${opt?.name}` : opt?.name || opt}
              <button
                className="ml-1 text-blue-900"
                onClick={() =>
                  toggleOption(isSportsList ? opt?.name : opt?.id || opt)
                }
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default MultiSelectWrapper;
